import { UserAvatar } from '@/components/ui/user-avatar';
import React, { useState } from 'react';
import { ColorValue } from 'react-native';
import { TabBarIcon } from './tab-bar-icon';

interface ProfileTabIconProps {
  color: ColorValue;
  focused: boolean;
  avatarUrl?: string;
  size?: number;
}

export function ProfileTabIcon({
  color,
  focused,
  avatarUrl,
  size = 28
}: ProfileTabIconProps) {
  // Track the uri that failed so a new avatar gets a fresh try.
  const [failedUri, setFailedUri] = useState<string | null>(null);

  // If no avatar URL is provided or image failed to load, show the default icon
  if (!avatarUrl || failedUri === avatarUrl) {
    return (
      <TabBarIcon
        name={focused ? 'person-circle' : 'person-circle-outline'}
        color={color}
        size={size}
      />
    );
  }

  // The tab button carries the label, so the avatar is decorative here.
  return (
    <UserAvatar
      uri={avatarUrl}
      size={size}
      decorative
      onError={() => setFailedUri(avatarUrl)}
      className="bg-transparent"
    />
  );
}
